import React from "react";
import ReactHtmlParser from "react-html-parser";

// import styled components
import { AboutContainer } from "./styled";

// import assets
import profilePlaceholder from "../../../assets/img/profile-placeholder.svg";

const About = ({ description, featuredProfile, name, sectionImage }) => {
  const headingMatch = description ? description.match(/<h2>(.*?)<\/h2>/i) : null;
  const headingContent = headingMatch ? headingMatch[1] : "";
  const copyContent = description ? description.replace(/<h2>.*?<\/h2>/i, "").trim() : "";

  return (
    <AboutContainer id="nav-about">
      {sectionImage ? <img className="about-section-image" src={sectionImage} alt={`OneTrust ${name}`} /> : null}
      {headingContent ? <h2 className="about-heading">{ReactHtmlParser(headingContent)}</h2> : null}
      <div className="about-content">
        {featuredProfile ? (
          <aside className="about-profile">
            <div
              className="about-headshot"
              style={{
                backgroundImage: `url("${featuredProfile.headshot || profilePlaceholder}")`,
              }}
            />
            <h3>{`${featuredProfile.firstName} ${featuredProfile.lastName}`.trim()}</h3>
            {featuredProfile.title ? <p className="about-title">{featuredProfile.title}</p> : null}
          </aside>
        ) : null}
        <div className="about-copy">{ReactHtmlParser(copyContent)}</div>
      </div>
    </AboutContainer>
  );
};

export default About;
